import { Component, OnInit } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute } from '@angular/router';
import { CommentsComponent } from '@shared/components/comments/comments.component';
import { CommonModule } from '@angular/common';
import { ModelType } from '@shared/constants/model-type.enum';

@Component({
  selector: 'app-folder-view',
  standalone: true,
  imports: [MatTableModule, MatFormFieldModule, MatInputModule, MatButtonModule, CommentsComponent, CommonModule], 
  templateUrl: './folder-view.component.html',
  styleUrl: './folder-view.component.scss'
})
export class FolderViewComponent implements OnInit {
  folderName: string = "";
  treeId!: number;
  projectId: number = 0;
  modelType!: ModelType;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.folderName = params['label'];
      this.modelType = params['modelType'];
      this.treeId = params['treeId'];
      this.projectId = params['projectId'];
    });
  }
}
